module.exports = __webpack_public_path__ + "static/media/fb.a710f48c.svg";